/**
 * Preview frames — scales each [data-preview-frame] iframe down from its desktop
 * viewport width (data-preview-width, default 1440) to the width of its square
 * wrapper, so the thumbnail shows the desktop layout instead of the mobile one.
 *
 * Done in JS rather than `transform: scale(calc(100cqw / 1440px))` because
 * length-by-length division in calc() is still too new to rely on.
 */
export function previewFrames() {
  const frames = document.querySelectorAll('[data-preview-frame]');
  if (!frames.length) return;

  const fit = (iframe) => {
    const wrap = iframe.parentElement;
    if (!wrap) return;
    const width = wrap.clientWidth;
    if (!width) return;
    const design = parseInt(iframe.dataset.previewWidth, 10) || 1440;
    iframe.style.transform = `scale(${width / design})`;
  };

  frames.forEach(fit);

  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const iframe = entry.target.querySelector('[data-preview-frame]');
        if (iframe) fit(iframe);
      });
    });
    frames.forEach((iframe) => {
      if (iframe.parentElement) ro.observe(iframe.parentElement);
    });
  } else {
    window.addEventListener('resize', () => frames.forEach(fit));
  }
}
